import { useTranslation } from 'react-i18next'
import { useFinpromContext } from 'hooks/context/useFinpromContext'
import { finpromSelfCategorisationPreferenceKey } from '../finpromPreferenceData'

export const useRetakeSelfCategorisation = () => {
  const { t } = useTranslation()
  const { accountPreferences, setAccountPreferences } = useFinpromContext() || {}

  const quizCategory = accountPreferences?.[finpromSelfCategorisationPreferenceKey]?.category
  const quizCategoryLabel = t(`finprom.selfCategorisation.category.${quizCategory}.label`)

  const onRetakeQuiz = () => {
    const updatedPreferences = { ...accountPreferences }
    updatedPreferences[finpromSelfCategorisationPreferenceKey].result = null
    setAccountPreferences(updatedPreferences)
    // TODO: handle retake quiz request - ONB-1506
  }

  return { quizCategoryLabel, onRetakeQuiz }
}
